"use strict";

var $ = require("jquery");

function dropdownPositionTop(el) {
    const navbarHeight = $('.header-bottom-wrapper').outerHeight();
    el.css({ 'top': navbarHeight });
}

export { dropdownPositionTop };